import React from 'react';
import { l } from 'app/blocks/common/codes';
import { useAuth } from 'app/blocks/common/providers/AuthProvider';
import StaticContent from 'app/blocks/static-content/static-content';

import 'app/blocks/common/css/helpout-alert.scss';

export default function RightMenu() {
    const { user } = useAuth();

    return (
        <div className="RightDashboardBlock col-lg-3 col-xl-2">
            {!!l('DASHBOARD.NEW_DASHBOARD_MESSAGE_VISIBLE', {}, '') && (
                <StaticContent seleniumid="dashboard-new" src="dashboard-new.html" />
            )}
            {user.primaryEmail && (
                <StaticContent
                    params={{ email: user.primaryEmail }}
                    seleniumid="dashboard-promo"
                    src="dashboard-promo.html"
                />
            )}
        </div>
    );
}
